import styled from 'styled-components';

interface IProps {
	gridArea?: string;
}

const Wrapper = styled.div<IProps>``;

export { Wrapper };
